import FullscreenIcon from "@mui/icons-material/Fullscreen"
import FullscreenExitIcon from "@mui/icons-material/FullscreenExit"
import { IconButton } from "@mui/material"
import { useState } from "react"

export const UIFullscreen = () => {
  const [isFullscreen, setIsFullscreen] = useState(
    document.fullscreenElement ? true : false
  )

  const toggleFullScreen = () => {
    if (document.fullscreenElement) {
      document.exitFullscreen()
      setIsFullscreen(false)
    } else {
      document.body.requestFullscreen()
      setIsFullscreen(true)
    }
  }
  return (
    <IconButton onClick={toggleFullScreen} sx={{ pointerEvents: "auto" }}>
      {isFullscreen ? (
        <FullscreenExitIcon color="primary" sx={{ fontSize: "1.3em" }} />
      ) : (
        <FullscreenIcon color="primary" sx={{ fontSize: "1.3em" }} />
      )}
    </IconButton>
  )
}
